// extracted by mini-css-extract-plugin
export var border = "_5r-0";
export var borderSelected = "_5r-1";
export var check = "_5r-6";
export var circle = "_5r-2";
export var circleInner = "_5r-4";
export var circleInnerDisabled = "_5r-8";
export var description = "_5r-3";
export var horizontal = "_5r-b";
export var input = "_5r-5";
export var label = "_5r-9";
export var radioButton = "_5r-d";
export var radioButtonNoCenter = "_5r-e";
export var radioGroup = "_5r-a";
export var rightRadio = "_5r-f";
export var subcontent = "_5r-g";
export var uncheck = "_5r-7";
export var vertical = "_5r-c";